export default "__VITE_ASSET__C1oDIAD8__"